import MojitoCore from 'mojito/core';
const ApiProvider = MojitoCore.Services.ApiProvider;

/**
 * Abstract promotions service to be implemented by different integrations.
 *
 * @class AbstractPromotionsService
 * @abstract
 * @memberof Mojito.Services.Promotions
 */
export default class AbstractPromotionsService extends ApiProvider {
    /**
     * Configure the service.
     * The configuration properties are specific to the concrete implementation.
     *
     * @param {{}} config - Config object.
     *
     * @function Mojito.Services.Promotions.AbstractPromotionsService#configure
     */
    // eslint-disable-next-line no-unused-vars
    configure(config) {
        // To be implemented by subclasses
    }

    /**
     * Subscribes to promotion channels.
     *
     * @param {{}} options - Options object.
     * @param {Function} onMessage - On message callback.
     * @param {Function} onFailed - On subscription failed callback.
     *
     * @function Mojito.Services.Promotions.AbstractPromotionsService#subscribe
     */
    // eslint-disable-next-line no-unused-vars
    subscribe(options, onMessage, onFailed) {}

    /**
     * Subscribes to promotion container channels.
     *
     * @param {{}} options - Options object.
     * @param {Function} onMessage - On message callback.
     * @param {Function} onFailed - On subscription failed callback.
     *
     * @function Mojito.Services.Promotions.AbstractPromotionsService#subscribeContainers
     */
    // eslint-disable-next-line no-unused-vars
    subscribeContainers(options, onMessage, onFailed) {}

    /**
     * Unsubscribes from promotion channels.
     *
     * @param {{}} options - Options object.
     *
     * @function Mojito.Services.Promotions.AbstractPromotionsService#unsubscribe
     */
    // eslint-disable-next-line no-unused-vars
    unsubscribe(options) {}

    /**
     * Unsubscribes from promotion container channels.
     *
     * @param {{}} options - Options object.
     *
     * @function Mojito.Services.Promotions.AbstractPromotionsService#unsubscribeContainers
     */
    // eslint-disable-next-line no-unused-vars
    unsubscribeContainers(options) {}

    /**
     * Unsubscribes a client from all promotion container channels.
     *
     * @param {string} clientId - Id of a subscriber.
     *
     * @function Mojito.Services.Promotions.AbstractPromotionsService#unsubscribeAllContainers
     */
    // eslint-disable-next-line no-unused-vars
    unsubscribeAllContainers(clientId) {}

    /**
     * Reset service instance.
     *
     * @function Mojito.Services.Promotions.AbstractPromotionsService#reset
     */
    reset() {}
}
